<template>
  <div id="page">
    <img
      :src="images.top"
      style="width: 100%; float: center; margin-top: 40px"
    />
    <div id="title-one">一、报告说明</div>
    <div id="title-two">1. 内容简介</div>
    <div id="content1">
      {{ this.content1 }}
    </div>
    <div id="content-li">
      <ul>
        <li>{{ this.content2 }}</li>
        <li>{{ this.content3 }}</li>
        <li v-html="content4" style="padding-top: 10px"></li>
      </ul>
    </div>

    <div id="title-two">2. 使用说明</div>
    <div id="content1">
      {{ this.info }}
    </div>

    <div id="footer">
      <span id="footer-red">1</span>
    </div>
  </div>
</template>

<script>
import { reportInfo } from "@/views/CNBM/data/content-text.js";
export default {
  data() {
    return {
      content1: reportInfo.content1,
      content2: reportInfo.content2,
      content3: reportInfo.content3,
      content4: reportInfo.content4,
      info: reportInfo.info,
      images: {
        top: require("@/views/CNBM/images/top.png"),
      },
    };
  },
  mounted() {},
  watch: {},
  methods: {},
};
</script>



// WEBPACK FOOTER //
// src/views/CNBMTalent/pages/page-one.vue